module.exports = __webpack_public_path__ + "static/assets/18d1229064d35b47202419220d54bb8c.svg";